import { createTheme, adaptV4Theme, checkboxClasses } from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import {
  ICON_ERROR,
  PRIMARY_BLUE,
  LIGHT_GREY,
  FADED_ICON_ERROR,
  WHITE,
  VERTICAL_SEPARATOR,
} from '../../Constants/Colors.constants';

export const importPageStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    padding: '0 30px',
  },
  importReviewWrapper: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  tableWrapper: {
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'auto',
  },
  progressBar: {
    flex: '1 0 100%',
    marginBottom: theme.spacing(2),
  },
  subHeader: {
    fontWeight: 'bold',
    flex: '1 0 100%',
    marginBottom: '30px',
  },
  importUploadSection: {
    flex: '1 0 100%',
    display: 'flex',
    margin: 'auto',
    justifyContent: 'space-between',
  },
  box: {
    marginRight: theme.spacing(2),
    '&:last-child': {
      marginRight: 0,
    },
    flex: '1 0 300px',
  },
  error: {
    display: 'flex',
    border: `1px solid ${ICON_ERROR}`,
    padding: '5px',
    marginTop: '20px',
    color: ICON_ERROR,
  },
  importHistory: {
    marginTop: theme.spacing(3),
  },
  modalButton: {
    marginBottom: 30,
    minWidth: 200,
    '&:first-of-type': {
      marginTop: 30,
    },
  },
  cell: {
    display: 'flex',
    height: '100%',
    padding: '16px',
    alignItems: 'center',
  },
  cellError: {
    border: `1px solid ${ICON_ERROR}`,
    backgroundColor: FADED_ICON_ERROR,
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'relative',
  },
  cellErrorText: {
    display: 'flex',
    color: ICON_ERROR,
    fontSize: '10px',
    letterSpacing: '0.3px',
    lineHeight: '9px',
    position: 'absolute',
    bottom: '5px',
  },
}));

export const getMuiTheme = () =>
  createTheme(
    adaptV4Theme({
      overrides: {
        MuiToolbar: {
          root: {
            height: '50px',
          },
        },
        MuiTable: {
          root: {
            backgroundColor: PRIMARY_BLUE,
            borderColor: VERTICAL_SEPARATOR,
            outlined: VERTICAL_SEPARATOR,
          },
        },
        // TODO please check if this is the correct class name
        MuiTableBody: {
          root: {
            width: '100%',
            borderRadius: 0,
            boxShadow: 'none',
            border: `2px solid ${VERTICAL_SEPARATOR}`,
          },
        },
        MuiTypography: {
          h6: {
            color: PRIMARY_BLUE,
            fontWeight: 'bold',
            size: '16px',
          },
        },
        MuiTableCell: {
          head: {
            borderTop: `1px solid ${VERTICAL_SEPARATOR}`,
            backgroundColor: `${LIGHT_GREY} !important`,
            outline: 'none',
          },
          body: {
            backgroundColor: 'white',
            outline: `1px solid ${VERTICAL_SEPARATOR}`,
          },
          footer: {
            backgroundColor: WHITE,
            border: `1px solid ${VERTICAL_SEPARATOR}`,
            height: '100px',
            padding: 'unset',
          },
        },
        // TODO please check
        // MUIDataTableBodyCell: {
        //   stackedCommon: {
        //     height: '100%',
        //   },
        // },
        MuiCheckbox: {
          colorPrimary: {
            [`& .${checkboxClasses['checked']}`]: {
              color: PRIMARY_BLUE,
            },
          },
        },
        MuiTablePagination: {
          root: {
            display: 'flex',
            flex: '1 0 100%',
          },
          toolbar: {
            display: 'flex',
            flex: '1 0 100%',
          },
          spacer: {
            display: 'none',
          },
          input: {
            marginRight: 'auto',
          },
          actions: {
            marginRight: 0,
          },
        },
      },
    }),
  );
